export const ROUTES_PREFIX = 'auth' as const;

export const PATHS_DICT = {
  CALLBACK: 'callback',
  ERROR: 'error',
  LOGIN: 'login',
  LOGOUT: 'logout',
  SIGNUP: 'signup'
} as const;
